
export default {
  name: 'OfficialsIcon',
  props: {
    classCss: { type: String, default: '' },
  },
}
